import * as React from 'react';

import Loader from 'components/ui/Loader';
import Typo from 'components/ui/Typo';

import s from './AuthPending.module.scss';

type AuthPendingProps = {
  message?: string;
};

const AuthPending: React.FC<AuthPendingProps> = ({ message }) => {
  return (
    <div className={s.root}>
      <Typo className={s.root__text}>{message ?? 'Ожидаем авторизацию...'}</Typo>
      <Loader className={s.root__loader} />
    </div>
  );
};

export default React.memo(AuthPending);
